import React, { useState } from 'react';
import { LOGO_SRC, BRAND_NAME } from '../constants/brand';

// Brand lockup for the header and footer.
//
// Renders the logo file at LOGO_SRC (see src/constants/brand.js). Until that
// file exists the <img> 404s and we fall back to the HD text wordmark, so the
// site never shows a broken image. Dropping the artwork at
// public/images/logo.png is the only step needed to switch over — no code
// change, no rebuild of these components.
const VARIANTS = {
  // Header sits on the orange bar: white chip, white type.
  header: {
    badge: 'bg-white text-primary-600',
    name: 'text-white',
    sub: 'text-white/80',
  },
  // Footer sits on the dark bar: orange chip, white type.
  footer: {
    badge: 'bg-primary-600 text-white',
    name: 'text-white',
    sub: 'text-primary-500',
  },
};

const SIZES = {
  sm: { badge: 'h-8 w-8 text-base', name: 'text-base', sub: 'text-[10px]' },
  md: { badge: 'h-9 w-9 text-lg', name: 'text-lg', sub: 'text-[11px]' },
};

const BrandLogo = ({ className = 'h-10', variant = 'header', size = 'sm' }) => {
  const [logoMissing, setLogoMissing] = useState(false);
  const tone = VARIANTS[variant] || VARIANTS.header;
  const scale = SIZES[size] || SIZES.sm;

  if (!logoMissing) {
    return (
      <img
        src={LOGO_SRC}
        alt={BRAND_NAME}
        className={`${className} w-auto object-contain`}
        onError={() => setLogoMissing(true)}
      />
    );
  }

  return (
    <span
      className={`${className} flex items-center gap-2.5 select-none`}
      aria-label={BRAND_NAME}
    >
      <span
        className={`${scale.badge} ${tone.badge} flex items-center justify-center font-heading font-black leading-none rounded-[2px]`}
      >
        HD
      </span>
      <span className="flex flex-col leading-none">
        <span className={`${scale.name} ${tone.name} font-heading font-black tracking-tight`}>
          HOME DEPOT
        </span>
        <span className={`${scale.sub} ${tone.sub} font-heading font-bold tracking-[0.28em]`}>
          SHEDS
        </span>
      </span>
    </span>
  );
};

export default BrandLogo;
